module.exports = __webpack_public_path__ + "static/media/wellness_blue.f47f7fbc.svg";